<template>
    <el-container class="mainJjglxxBody">
        <el-col class="box">
            <el-card class="box-card" shadow="never">
                <div slot="header" class="clearfix">
                    <div class="headOne">{{JjjgxxList.JGMC}}</div>
                    <div class="headSecond">{{JjjgxxList.GSDZ}}</div>
                </div>
                <el-row>
                <span class="xxContent1">
                    统一社会信用代码：
                </span>
                    <span class="xxContent2">
                    {{JjjgxxList.BAZH}}
                </span>
                </el-row>
                <el-row>
                <span class="xxContent1">
                    租金托管账户：
                </span>
                    <span class="xxContent2">
                    {{JjjgxxList.BAZH}}
                </span>
                </el-row>
                <el-row>
                <span class="xxContent1">
                    区属：
                </span>
                    <span class="xxContent2">
                    {{JjjgxxList.BAZH}}
                </span>
                </el-row>
                <el-row>
                <span class="xxContent1">
                    法定代表人：
                </span>
                    <span class="xxContent2">
                    {{JjjgxxList.BAZH}}
                </span>
                </el-row>
                <el-row>
                <span class="xxContent1">
                    租赁类别：
                </span>
                    <span class="xxContent2">
                    {{JjjgxxList.BAZH}}
                </span>
                </el-row>
                <el-row>
                <span class="xxContent1">
                    联系电话：
                </span>
                    <span class="xxContent2">
                    {{JjjgxxList.BAZH}}
                </span>
                </el-row>
                <el-row>
                <span class="xxContent1">
                    注册资金：
                </span>
                    <span class="xxContent2">
                    {{JjjgxxList.BAZH}}
                </span>
                </el-row>
                <el-row>
                <span class="xxContent1">
                    经营范围：
                </span>
                    <span class="xxContent2">
                    {{JjjgxxList.BAZH}}
                </span>
                </el-row>
                <el-row>
                <span class="xxContent1">
                    租赁经营方式：
                </span>
                    <span class="xxContent2">
                    {{JjjgxxList.BAZH}}
                </span>
                </el-row>
                <el-row>
                <span class="xxContent1">
                   工商注册日期：
                </span>
                    <span class="xxContent2">
                    {{JjjgxxList.BAZH}}
                </span>
                </el-row>
                <el-row>
                <span class="xxContent1">
                    备案证明有效期：
                </span>
                    <span class="xxContent2">
                    {{JjjgxxList.BAZH}}
                </span>
                </el-row>
                <el-row>
                <span class="xxContent1">
                    登记日期：
                </span>
                    <span class="xxContent2">
                    {{JjjgxxList.BAZH}}
                </span>
                </el-row>
                <el-row>
                <span class="xxContent1">
                   改建分散：
                </span>
                    <span class="xxContent2">
                    {{JjjgxxList.BAZH}}
                </span>
                </el-row>
                <el-row>
                <span class="xxContent1">
                    房屋挂牌量：
                </span>
                    <span class="xxContent2">
                    {{JjjgxxList.BAZH}}
                </span>
                </el-row>
                <el-row>
                <span class="xxContent1">
                    房屋网签量：
                </span>
                    <span class="xxContent2">
                    {{JjjgxxList.BAZH}}
                </span>
                </el-row>
                <el-row>
                <span class="xxContent1">
                    房屋备案量：
                </span>
                    <span class="xxContent2">
                    {{JjjgxxList.BAZH}}
                </span>
                </el-row>
                <el-row>
                <span class="xxContent1">
                    租赁房源情况基本信息：
                </span>
                    <span class="xxContent2">
                    {{JjjgxxList.BAZH}}
                </span>
                </el-row>
            </el-card>
            <el-row class="buttonRow">
                <el-button type="primary" @click="onSubmit">查看门店</el-button>
                <el-button type="primary" @click="resetHt">查看从业人员</el-button>
            </el-row>
        </el-col>
    </el-container>
</template>

<script>
    export default {
        name: "jjjggs_cx",
        data() {
            return {
                JjjgxxList:{
                    JGMC:'汉中鸿润置业有限公司',
                    GSDZ:'汉中市汉台区汉中颐高互联网双创园',
                    BAZH:'某某',
                },
            }
        },
    }
</script>

<style scoped>
    @import "../../assets/css/jjgl/jjglxx_main.css";
</style>